var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-us"},[_c('a',{attrs:{"href":`tel:${_vm.supplierPhone}`}},[_vm._v("Need help?"),_c('br'),_vm._v("Call "),_c('b',[_vm._v(_vm._s(_vm.supplierPhone))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }